import { Link, usePage } from '@inertiajs/react'
import { Network } from 'lucide-react'
import type { SharedProps } from '@/frontend/types/inertia'

/** Organization entry. Project navigation lives in the project shell. */
export default function ForgeMenu({ active, onNavigate }: { active: boolean; onNavigate: () => void }) {
  const { props } = usePage<SharedProps>()
  return <Link href="/dashboard/discovery/projects" onClick={onNavigate} data-testid="wfn-discovery-link" aria-current={active ? 'page' : undefined} className={`flex min-h-9 items-center gap-2 rounded-[10px] px-3 text-[13.5px] font-medium ${active ? 'bg-accent text-foreground' : 'text-muted-foreground hover:bg-accent hover:text-foreground'}`}>
    <Network className="size-4 shrink-0" strokeWidth={1.75} />{props.navigationLabels.discovery}
  </Link>
}
